import { CurrencyService } from "../services/CurrencyService";
import { TickerService } from "../services/TickerService";
import { formatMoney } from "../utils/formatters";

export class Calculator {
  private wrapper: JQuery<HTMLElement>;
  private static WRAPPER_OPEN_CLASS = "calculator-open";
  private input: JQuery<HTMLInputElement>;
  private isOpen = false;
  private currencies: Currency[] = [];
  private _currencyFrom: Currency = {} as Currency;
  private _currencyTo: Currency;
  private baseCurrency: Currency;
  private priceFromElement: JQuery<HTMLInputElement>;

  constructor() {
    this.wrapper = $(".calculator-module-wrapper");
    this.input = this.wrapper.find<HTMLInputElement>(
      ".calculator-search-input"
    );
    this.priceFromElement = this.wrapper.find<HTMLInputElement>(
      ".calculator-currency-from .calculator-currency-price"
    );
    this.baseCurrency = this._currencyTo = {
      code: "BRL",
      name: "Brazilian Real",
      sellPrice: 1,
      icon: "/wp-content/themes/foxbit/static/arquivos/currency-icons/brl.svg",
    } as Currency;

    this.bindEvents();
    this.getCurrencies();
  }

  set currencyFrom(currency: Currency) {
    const from = this.wrapper.find(".calculator-currency-from");
    this._currencyFrom = currency;

    if (!currency?.code) {
      return;
    }

    from
      .find(".calculator-currency-icon")
      .html("")
      .append($("<img>", { src: currency.icon }));
    from.find(".calculator-currency-initials").html(currency.code);
    from.find(".calculator-currency-name").html(currency.name);

    this.wrapper
      .find(".calculator-currency-to .calculator-currency-price")
      .html(formatMoney(currency.sellPrice)!!);
    this.setCalculatedSellPrice();
  }

  set currencyTo(currency: Currency) {
    const to = this.wrapper.find(".calculator-currency-to");
    this._currencyTo = currency;

    if (!currency?.code) {
      return;
    }

    to.find(".calculator-currency-icon")
      .html("")
      .append($("<img>", { src: currency.icon }));
    to.find(".calculator-currency-initials").html(currency.code);
    to.find(".calculator-currency-name").html(currency.name);

    this.setCalculatedSellPrice();
  }

  private get priceFrom(): number {
    try {
      const val = parseFloat(
        ((this.priceFromElement.val() as string) || "").replace(/\,/g, "") ||
          "0"
      );

      return val !== NaN ? val : 0;
    } catch {
      return 0;
    }
  }

  private bindEvents() {
    this.wrapper
      .find(".calculator-change-icon")
      .on("click", this.onChangeIconClick.bind(this));
    this.wrapper
      .find(".calculator-search-close")
      .on("click", this.onSearchClearClick.bind(this));
    this.wrapper.on(
      "click",
      ".calculator-change-item",
      this.onChangeItemClick.bind(this)
    );
    this.wrapper
      .find(".calculator-currency-to .calculator-currency-description")
      .on("click", this.onToDescriptionClick.bind(this));
    this.priceFromElement.on("focus", () => {
      this.priceFromElement.select();
    });
    this.priceFromElement.on("input", (e) => {
      this.onPriceKeyup();
    });

    this.input.on("keyup", this.onSerachKeyup.bind(this));
    this.wrapper.on("mouseleave", this.onWrapperMouseLeave.bind(this));
  }

  private setCalculatedSellPrice() {
    const priceTo =
      (this._currencyFrom.code === this.baseCurrency.code
        ? this.priceFrom / this._currencyTo.sellPrice
        : this.priceFrom * this._currencyFrom.sellPrice) || 0;

    // this.wrapper
    //   .find(".calculator-currency-from .calculator-currency-price")
    //   .html(this.priceFrom.toString());
    this.wrapper
      .find(".calculator-currency-to .calculator-currency-price")
      .html(formatMoney(priceTo, this._currencyTo.code)!!);

    // console.log(this._currencyFrom, this._currencyTo);
  }

  private async getCurrencies() {
    this.currencies = await TickerService.get();
    this.currencyFrom =
      (await CurrencyService.getSelected()) || this.currencies[0];

    const template = this.wrapper.find(".calculator-change-item-template");

    if (!template.length) {
      return;
    }

    const items = this.currencies.map((currency) => {
      const item = $(template.html());
      item.data("code", currency.code);
      item
        .find(".calculator-change-item-icon")
        .html("")
        .append($("<img>", { src: currency.icon }));
      item.find(".calculator-change-item-initials").html(currency.code);
      item.find(".calculator-change-item-name").html(currency.name);

      return item;
    });

    this.wrapper.find(".calculator-change-list").append(items);
    this.wrapper.addClass("calculator-ready");
  }

  private onChangeIconClick(e: JQuery.ClickEvent) {
    e.preventDefault();

    const from = this._currencyFrom;
    const to = this._currencyTo;

    this.currencyTo = from;
    this.currencyFrom = to;
  }

  private onSearchClearClick(e: JQuery.ClickEvent) {
    e.preventDefault();

    this.clearText();
  }

  private onSerachKeyup(e: JQuery.KeyUpEvent) {
    this.filterItems(this.input.val() as string);
  }

  private onWrapperMouseLeave(e: JQuery.MouseLeaveEvent) {
    this.close();
  }

  private onChangeItemClick(event: JQuery.ClickEvent) {
    const code = $(event.currentTarget).data("code");
    const currency = this.currencies.find((c) => c.code === code);

    event.preventDefault();

    this.currencyFrom = currency!!;
    this.currencyTo = this.baseCurrency;
    this.close();
  }

  private onToDescriptionClick(e: JQuery.ClickEvent) {
    e.preventDefault();

    this.open();
  }

  private onPriceKeyup() {
    this.setCalculatedSellPrice();
  }

  open() {
    if (!this.isOpen) {
      this.wrapper.addClass(Calculator.WRAPPER_OPEN_CLASS);
      this.isOpen = true;
    }
  }

  close() {
    if (this.isOpen) {
      this.isOpen = false;
      this.wrapper.removeClass(Calculator.WRAPPER_OPEN_CLASS);
      this.clearText();
    }
  }

  clearText() {
    this.input.val("").trigger("keyup");
  }

  filterItems(search: string) {
    const itemClass = ".calculator-change-item";
    const $items = this.wrapper.find(itemClass);

    $items.hide().filter(`:Contains(${search})`).closest(itemClass).show();
  }
}
